class BstCollectionTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-tab-trigger]');
    this.panels = this.querySelectorAll('[data-tab-panel]');
    this.viewAllLink = this.querySelector('[data-view-all]');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.switchTab(tab.dataset.tabTrigger);
      });
    });
  }

  switchTab(index) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tabTrigger === index;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== index;
    });

    if (this.viewAllLink) {
      const activeTab = this.querySelector(`[data-tab-trigger="${index}"]`);
      if (activeTab) {
        this.viewAllLink.href = activeTab.dataset.collectionUrl || '#';
        this.viewAllLink.querySelector('[data-view-all-text]').innerHTML =
          'View All <span class="collection-tabs__view-all-title">' + (activeTab.dataset.collectionTitle || '') + ' </span>';
      }
    }
  }
}

customElements.define('bst-collection-tabs', BstCollectionTabs);
